<template>
  <div>
    <!--기본정보-->
    <field-select-module v-model="form.stdInfo" :board="this.board" :is-print="isPrint" />

    <div class="mt-28px">
      <h5 class="mb-4"><i class="dot"></i>사고 발생 상황 보고 (수시, 최종보고)</h5>
      <div class="writeGridContainer">
        <div class="writeGridLineItem">
          <div>보고 목적</div>
          <span v-if="isPrint" class="print-input">{{ form.inputA_1 }}</span>
          <div v-else class="w-full flex-1 flex gap-4" style="align-self: center;">
            <vs-radio v-model="form.inputA_1" :disabled="board.readonly" vs-name="object" vs-value="방침필요">방침필요</vs-radio>
            <vs-radio v-model="form.inputA_1" :disabled="board.readonly" vs-name="object" vs-value="상황">상황</vs-radio>
            <vs-radio v-model="form.inputA_1" :disabled="board.readonly" vs-name="object" vs-value="결과보고(지시사항 등)">결과보고(지시사항 등)</vs-radio>
            <vs-radio v-model="form.inputA_1" :disabled="board.readonly" vs-name="object" vs-value="회의/행사">회의/행사</vs-radio>
            <vs-radio v-model="form.inputA_1" :disabled="board.readonly" vs-name="object" vs-value="기타">기타</vs-radio>
          </div>
        </div>
        <div class="writeGridLineItem">
          <div>시급성</div>
          <span v-if="isPrint" class="print-input">{{ form.inputA_2 }}</span>
          <div v-else class="w-full flex-1 flex gap-4" style="align-self: center;">
            <vs-radio v-model="form.inputA_2" :disabled="board.readonly" vs-name="urgency" vs-value="긴급(중대재해)">긴급(중대재해)</vs-radio>
            <vs-radio v-model="form.inputA_2" :disabled="board.readonly" vs-name="urgency" vs-value="중요">중요</vs-radio>
            <vs-radio v-model="form.inputA_2" :disabled="board.readonly" vs-name="urgency" vs-value="보통">보통</vs-radio>
          </div>
        </div>
        <div class="writeGridLineItem">
          <div>보고 요지</div>
          <span style="align-self: center;">보고서의 핵심 내용을 압축하여 1~2줄로 작성(대책·대안 중심 작성)</span>
        </div>
      </div>
      <div>■ 재난 및 안전관리 기본법 시행규칙 [별지 제1호서식 활용] <span style="color: #7e72f2">&lt;개정 2012.12.6&gt;</span></div>
    </div>

    <div class="mt-28px">
      <div class="mb-4 flex" style="align-items: center;">
        <h5><i class="dot"></i>사고개요</h5>
        <vs-button class="ml-auto" type="border" color="secondary" @click="showPrevBoard=true">중대시민재해 발생 보고서 불러오기</vs-button>
      </div>
      <div class="writeGridContainer">
        <div>
          <div>일시</div>
          <span v-if="isPrint" class="print-input"> {{ form.inputB_1 }} </span>
          <DateSelector v-else :readonly="board.readonly" placeholder="날짜선택" v-model="form.inputB_1" />
        </div>
        <div>
          <div>시간</div>
          <span v-if="isPrint" class="print-input"> {{ form.inputB_2 }} </span>
          <time-selector v-else :readonly="board.readonly" placeholder="시간선택" v-model="form.inputB_2" />
          <div class="ml-1">경</div>
        </div>
        <div>
          <div>장소</div>
          <span v-if="isPrint" class="print-input"> {{ form.inputB_3 }} </span>
          <ml-input v-else :readonly="board.readonly" v-model="form.inputB_3" />
        </div>
        <div class="writeGridLineItem">
          <div>기본현황</div>
          <span v-if="isPrint" class="print-textarea"> {{ form.inputB_4 }} </span>
          <ml-textarea v-else rows="5" v-model="form.inputB_4" :readonly="board.readonly" />
        </div>
        <div class="writeGridLineItem">
          <div>원인</div>
          <span v-if="isPrint" class="print-textarea"> {{ form.inputB_5 }} </span>
          <ml-textarea v-else rows="5" v-model="form.inputB_5" :readonly="board.readonly" placeholder="원인 미상의 지하층 화재발생, 현재 원인 조사 중"/>
        </div>
        <div class="writeGridLineItem">
          <div>피해상황(인명피해)</div>
          <span v-if="isPrint" class="print-textarea"> {{ form.inputB_6 }} </span>
          <ml-textarea v-else rows="5" v-model="form.inputB_6" :readonly="board.readonly" placeholder="- 사망 2명(종사자 1, 시민 1)"/>
        </div>
        <div class="writeGridLineItem">
          <div>피해상황(재산피해)</div>
          <span v-if="isPrint" class="print-textarea"> {{ form.inputB_7 }} </span>
          <ml-textarea v-else rows="5" v-model="form.inputB_7" :readonly="board.readonly" />
        </div>
        <div class="writeGridLineItem">
          <div>피해상황(그 밖의 피해)</div>
          <span v-if="isPrint" class="print-textarea"> {{ form.inputB_8 }} </span>
          <ml-textarea v-else rows="5" v-model="form.inputB_8" :readonly="board.readonly" />
        </div>
      </div>
    </div>

    <div class="mt-28px">
      <h5 class="mb-4"><i class="dot"></i>응급조치 및 복구 사항</h5>
      <div class="writeGridContainer">
        <div class="writeGridLineItem">
          <div>조치사항</div>
          <span v-if="isPrint" class="print-textarea"> {{ form.inputC_1 }} </span>
          <ml-textarea v-else rows="5" v-model="form.inputC_1" :readonly="board.readonly" placeholder="구급사항, 복구사항 등"/>
        </div>
        <div class="writeGridLineItem">
          <div>동원사항</div>
          <span v-if="isPrint" class="print-textarea"> {{ form.inputC_2 }} </span>
          <ml-textarea v-else rows="5" v-model="form.inputC_2" :readonly="board.readonly" placeholder="- 소방인력 및 장비
▸ 인력 : 명(소방공무원 명, 의용소방대 명)
▸ 장비 : 대(OOOO 대, OOOOO 대, OOOO 대)
- 소방 외의 인력 및 장비
▸ 인력 : 명(공무원 명, 경찰관 명, 민간인)
※ 민간인 : 명(대한적십자사 명, 자율방재단 명, OOOO 명)
▸ 장비 : 대(OOOO 대, OOOOO 대, OOOO 대)"/>
        </div>
      </div>
    </div>

    <div class="mt-28px">
      <h5 class="mb-4"><i class="dot"></i>지원 및 협조사항 (유관 기관·단체 등)</h5>
      <span v-if="isPrint" class="print-textarea"> {{ form.inputD_1 }} </span>
      <ml-textarea v-else rows="5" v-model="form.inputD_1" :readonly="board.readonly" placeholder="(필요시 작성)"/>
    </div>

    <div class="mt-28px">
      <h5 class="mb-4"><i class="dot"></i>향후 전망 및 대책 (구조, 구호, 복구, 피해자 지원 등)</h5>
      <span v-if="isPrint" class="print-textarea"> {{ form.inputE_1 }} </span>
      <ml-textarea v-else rows="5" v-model="form.inputE_1" :readonly="board.readonly" />
    </div>
    <span>붙임 : 피해대응 상세 내용, 인명피해 세부현황, 재난관련 기관 연락처 각 1부.</span>

    <file-upload-module :readonly="board.readonly" v-model="form.fileList" :is-print="isPrint" class="mt-28px" />

    <popup-load-prev-board v-model="showPrevBoard" :setBoardId="640" @selectRowData="selectRowData" />
  </div>
</template>

<script>
import PopupPlanProject from "@/views/project/popup/PopupPlanProject";
import DateSelector from "@/components/selector/DateSelector";
import PopupProjectSetting from "@/views/project/PopupProjectSetting";
import MemberSelector from "@/components/selector/MemberSelector";
import CompanySelector from "@/components/selector/CompanySelector";
import FileUploader from "@/components/FileUploader";
import SearchNavStartEnd from "../../../../components/nav/SearchNavStartEnd.vue";
import FileUploadModule from "../../../modules/FileUploadModule.vue";
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import TimeSelector from "@/components/selector/TimeSelector.vue";
import TableCustom from "@/components/TableCustom.vue";
import PhotoUploadGridModule from "@/views/modules/PhotoUploadGridModule.vue";
import PopupLoadPrevBoard from "@/popup/PopupLoadPrevBoard.vue";

export default {
  components: {
    PopupLoadPrevBoard,
    PhotoUploadGridModule,
    TableCustom,
    TimeSelector,
    FileUploader,
    CompanySelector,
    MemberSelector,
    PopupProjectSetting,
    DateSelector,
    PopupPlanProject,
    SearchNavStartEnd,
    FileUploadModule,
    FieldSelectModule,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  watch: {
    value: {
      important: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
  },
  computed: {
    projectId() {
      return parseInt(this.$route.params.proj_id);
    },
  },
  data() {
    return {
      showPrevBoard: false,
      form: {
        stdInfo: {},

        inputA_1: "",
        inputA_2: "",

        inputB_1: "",
        inputB_2: "",
        inputB_3: "",
        inputB_4: "▪ 의료법인 : 0000단(이사장 : 000 )\n" +
          "▪ 주 소 지 : 00시 000구 000로 00\n" +
          "▪ 의료현황 : 의료진47명(의사6,간호사16, 조무사 25), 4개(재활·가정의학과, 신경외과, 정형외과)\n" +
          "▪ 병상현황 : 44병실, 220병상(지하 1층 재활·통증치료실, 1층 진료실, 2층~11층 입원실)\n" +
          "▪ 규 모 : 지하2층 ~ 지상11층(연면적 0,000㎡)",
        inputB_5: "",
        inputB_6: "",
        inputB_7: "",
        inputB_8: "",

        inputC_1: "",
        inputC_2: "",

        inputD_1: "",
        inputE_1: "",

        fileList: [],
      },
    };
  },
  methods: {
    selectRowData(data) {
      if (!data) return

      this.form.inputB_1 = data.inputB_1
      this.form.inputB_2 = data.inputB_2
      this.form.inputB_3 = data.inputB_3
      this.form.inputB_4 = data.inputB_4
      this.form.inputB_5 = data.inputB_5
      this.form.inputB_6 = data.inputB_6
      this.form.inputB_7 = data.inputB_7
      this.form.inputB_8 = data.inputB_8
    }
  },
};
</script>
